<template>
  <div class="subtopic-container-desktop" v-if="data">
    <div class="header">
      <router-link to="/kit" tag="div" class="back-button"></router-link>
      <img class="topic-icon" v-bind:src="imgUrl"/>
      <h4>{{topicTitle}}</h4>
    </div>
    <div class="tab-bar">
      <div class="tab-option" @click="setSelectedSubtopicIndex(index)" v-bind:class="{active : index == selectedSubtopicIndex}" v-for="(topic, index) in data" :key="index">{{lang == 'ar' ? topic.subtopic_AR : topic.subtopic_EN}}</div>
    </div>
    <div class="subtopic-content">
      <div class="image-content">
        <img class="image-subcat" v-if="data[selectedSubtopicIndex] && data[selectedSubtopicIndex].image_link != ''" v-bind:src="data[selectedSubtopicIndex].image_link"/>
      </div>
      <div class="subtopic-text" v-bind:class="{noside : !showSide}">
        <div class="side-content" v-if="showSide">
          <div class="advice" v-if="advice">{{advice}}</div>
          <div class="stats" v-if="stats" v-html="stats"></div>
        </div>
        <div class="main-content">
          <div class="paragraph" v-html="textBlock"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import textFormat from '@/utils/textFormat'

  export default {
    name: "subtopic-component-desktop",
    props: ['data'],
    data(){
      return{
        selectedSubtopicIndex: 0
      }
    },
    created() {
      if (this.data) {
        this.selectedSubtopicIndex = this.data.length - 1
      }
    },
    computed: {
      lang () {
        return this.$i18n.locale
      },
      topic () {
        if (this.data.length > 0)
          return this.data[0].topic_EN
        return ''
      },
      topicTitle () {
        if (this.data.length > 0)
          return  this.lang == 'ar' ? this.data[0].topic_AR : this.data[0].topic_EN
        return ''
      },
      imgUrl() {
        return '~@/../static/icons/kit/green/' + this.topic.split(' ').join('_').toLowerCase() + '.svg'
      },
      textBlock() {
        let blocks = []
        if(this.data[this.selectedSubtopicIndex]) {
          let text = this.lang == 'ar' ? this.data[this.selectedSubtopicIndex].paragraph_AR : this.data[this.selectedSubtopicIndex].paragraph_EN
          blocks = textFormat.formatParagraphs(text)
        }
        return blocks
      },
      advice() {
        let advice = ''
        if (this.data[this.selectedSubtopicIndex]) {
          advice = this.lang == 'ar' ? this.data[this.selectedSubtopicIndex].advices_CR_AR : this.data[this.selectedSubtopicIndex].advices_CR_EN
        }
        return advice
      },
      stats() {
        var styleVar = {
          'color': '#63EAAD',
          'display': 'inline-block',
          'width': '100%',
          'text-align': 'center',
          'font-size': '50px'
        }
        let stats = this.lang == 'ar' ? this.data[this.selectedSubtopicIndex].stats_AR : this.data[this.selectedSubtopicIndex].stats
        if (stats) {
          var chunks = stats.split("*")
          if (chunks.length == 3)
            stats = chunks[0] + "<div class='data-value' style='color: #63eaad; font-size: 40px; font-weight: bold'>" + chunks[1] + "</div>" + chunks[2]
          stats = stats.split('\\').join('<br/>')
          return stats
        }
        return ''
      },
      showSide() {
        return this.advice.length > 0 || this.stats.length > 0
      }
    },
    methods: {
      setSelectedSubtopicIndex (index) {
        this.selectedSubtopicIndex = index
      }
    },
    watch: {
      data (val) {
        this.selectedSubtopicIndex = this.data.length - 1
      }
    },
  }
</script>

<style lang="stylus">
.subtopic-container-desktop
  text-align left 
  min-height: 90px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3px 6px #cdcdcd;
  color: #707070;
  width: 80%;
  margin-left: 10%;
  margin-bottom 20px;
  display flex
  flex-direction column
  
  .header
    display flex
    flex-direction row
    align-items center
    color #55CCAA
    min-height 100px
    border-bottom 1px solid rgba(112, 112, 112, 0.25)
    .back-button
      margin-left 20px
      width 20px
      height 20px
      background: url('~@/../static/icons/back-green.svg') no-repeat left center;
    img
      margin-left 20px
      height 80px
    h4
      margin 0
      margin-left 20px
      font-size 35px
      text-transform capitalize
      display: flex;
  .tab-bar
    display flex
    flex-direction row-reverse  
    width 100%
    .tab-option
      display flex
      flex: 1 1 40px
      color #707070
      justify-content center
      text-align center
      padding 0 10px
      min-height 60px
      align-items center
      cursor pointer
      border-right : 1px solid #ececec
      border-bottom: 8px solid #ececec
      &.active
        border-bottom: 8px solid #72E3C3

  .subtopic-content
    display flex
    flex-direction column
    font-size:20px;
    .image-content
      justify-content center
      text-align center
      img 
        margin-top 15px
        width 40%
        min-height 80px
    .subtopic-text
      display flex
      flex-direction row
      width 100%
      margin-top 15px
      &.noside
        justify-content center
      .side-content
        display flex
        flex-direction column
        width 40%
        margin 30px
        .advice
          margin-bottom: 15px;
          font-size: 18px;
          text-align: center;
          padding-bottom: 30px;
        .advice:before
          content: '"';
          color: #63EAAD;
          font-size: 38px;
          display: inline-block;
          width: 100%;
          text-align: center;
        .stats
          padding-top: 30px;
          border-top: 1px solid #ccc;
          margin-top: 15px;
          text-align: center;
          font-size: 14px
        .data-value
          color: #63EAAD;
          display: inline-block;
          width: 100%;
          text-align: center;
          font-size: 50px;
      
      .main-content
        display flex
        margin 30px
        width 60%
        flex-direction column
        .paragraph
          margin-bottom: 10px;

.ar
  .main-content
    text-align right 
    .text-list
      direction rtl !important

  .subtopic-container-desktop
    .tab-bar
      flex-direction row

</style>



// WEBPACK FOOTER //
// src/components/SubtopicComponentDesktop.vue